module.exports = __webpack_public_path__ + "static/media/gallery.c0db55e0.png";